export default __webpack_public_path__ + "static/media/sweet_tofu_slushie_thumbnail.fe802485.JPG";